// Form rules for issuing a token. They mirror data/schemas/api_token.js.

export const NAME_MAX = 120;

// The three kinds the backend takes, with what each one can actually do —
// straight from the bundles in core/authz/roles.js. A person choosing here is
// choosing a permission set, and the names alone do not say which.
export const TOKEN_KIND_OPTIONS = [
    {
        value: 'agent_slave',
        label: 'Esclavo',
        detail: 'Toma tareas y las entrega. NO puede revisar: quien codea no aprueba.',
    },
    {
        value: 'agent_master',
        label: 'Maestro',
        detail: 'Desglosa tiers, publica contratos y revisa entregas. No toma tareas.',
    },
    {
        value: 'cli',
        label: 'CLI',
        detail: 'Solo lectura, para una herramienta de línea de comandos.',
    },
];

export const EMPTY_VALUES = {
    user_id: '',
    name: '',
    kind: 'agent_slave',
    project_id: '',
    repository_id: '',
    expires_at: '',
};

export function validate(values) {
    const errors = {};
    const name = values.name.trim();

    if (!values.user_id) errors.user_id = 'El token pertenece a una persona: falta cuál';
    if (!name) errors.name = 'El nombre del token es requerido';
    else if (name.length > NAME_MAX) errors.name = `No puede pasar de ${NAME_MAX} caracteres`;

    if (!TOKEN_KIND_OPTIONS.some(option => option.value === values.kind)) {
        errors.kind = 'El tipo de token no es válido';
    }

    // The backend refuses a date in the past, and says so. Catching it here
    // saves a round trip and puts the message next to the field.
    if (values.expires_at) {
        const when = new Date(values.expires_at);
        if (Number.isNaN(when.getTime())) errors.expires_at = 'La fecha no es válida';
        else if (when.getTime() <= Date.now()) {
            errors.expires_at = 'El vencimiento tiene que estar en el futuro';
        }
    }

    return errors;
}

// `project_id` is NOT in the payload and that is not an omission: a token has
// no project. It is asked for because it is the only filter the repository
// list takes, so it is how somebody finds the repository — and then it is
// dropped.
export function toIssuePayload(values) {
    const payload = {
        user_id: Number(values.user_id),
        name: values.name.trim(),
        kind: values.kind,
    };

    if (values.repository_id) payload.repository_id = Number(values.repository_id);
    if (values.expires_at) payload.expires_at = new Date(values.expires_at).toISOString();

    return payload;
}
